/*!-----------------------------------------------------------
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Version: 0.38.0-dev.20230422(8270c45a385a180a53fd8ef8e3a189b1471100ed)
 * Released under the MIT license
 * https://github.com/microsoft/vscode/blob/main/LICENSE.txt
 *-----------------------------------------------------------*/

define("vs/base/common/worker/simpleWorker.nls.zh-cn", {
	"vs/base/common/platform": [
		"_",
	]
});